import React from 'react';
import { Shield, Phone, Mail, Globe, ExternalLink } from 'lucide-react';

export function LegalFooter() {
  return (
    <div className="bg-gray-50 dark:bg-gray-800/50 border-t border-gray-100 dark:border-gray-700/50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="text-center space-y-6">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Shield className="w-5 h-5 text-gray-400 dark:text-gray-500" />
            <h3 className="text-sm font-bold text-gray-700 dark:text-gray-300">
              ACS - Assurances voyage & expatriation
            </h3>
          </div>

          <div className="text-xs text-gray-500 dark:text-gray-400 space-y-1">
            <p>Societe de courtage d'assurances - 153 rue de l'Universite 75007 Paris - France</p>
            <p>317 218 188 RCS Paris - S.A.S. au capital de 150 000 EUR</p>
            <p>
              N ORIAS 07 000 350 -{' '}
              <a href="http://www.orias.fr" target="_blank" rel="noopener noreferrer" className="text-emerald-600 dark:text-emerald-400 hover:underline">
                www.orias.fr
              </a>
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 pt-4 border-t border-gray-200 dark:border-gray-700/50">
            <a href="tel:+33140479100" className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors">
              <Phone className="w-3.5 h-3.5" />
              +33 (0)1 40 47 91 00
            </a>
            <a href="mailto:pvtistes@acs-ami.com" className="flex items-center gap-2 text-xs text-emerald-600 dark:text-emerald-400 hover:text-emerald-700 dark:hover:text-emerald-300 transition-colors">
              <Mail className="w-3.5 h-3.5" />
              pvtistes@acs-ami.com
            </a>
            <a href="https://www.acs-ami.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-xs text-emerald-600 dark:text-emerald-400 hover:text-emerald-700 dark:hover:text-emerald-300 transition-colors">
              <Globe className="w-3.5 h-3.5" />
              www.acs-ami.com
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>

          <div className="pt-4 border-t border-gray-200 dark:border-gray-700/50">
            <p className="text-[11px] text-gray-400 dark:text-gray-500 italic max-w-2xl mx-auto leading-relaxed">
              Assurance de Responsabilite Civile Professionnelle et Garantie Financiere conformes au Code des Assurances. Exerce sous le controle de l'ACPR, 4 Pl. de Budapest CS 92459, 75436 Paris. Cette page est redigee sous la responsabilite exclusive d'ACS, societe de courtage d'assurance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
